import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
export class TextPreview extends React.PureComponent {
    render() {
        return (_jsx("span", { className: 'rpx-text', title: this.props.label, style: this.props.style, children: this.props.content }));
    }
}
//# sourceMappingURL=preview.js.map